import { render, staticRenderFns } from "./orderdetails.vue?vue&type=template&id=839a3e64&scoped=true"
import script from "./orderdetails.vue?vue&type=script&lang=js"
export * from "./orderdetails.vue?vue&type=script&lang=js"
import style0 from "./orderdetails.vue?vue&type=style&index=0&id=839a3e64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839a3e64",
  null
  
)

export default component.exports